import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration, SystemInfoService } from '../../api-client';
import { SystemInfo } from '../../models/systemInfo';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SysInfoService extends SystemInfoService {

  constructor(
    httpClient: HttpClient,
    config: Configuration
  ) {
    super(httpClient, config.basePath!, config);
  }

  getSystemInfo(): Observable<SystemInfo> {
    return this.getSystemInfoEndpoint();
  }
}
